import { useLocation } from 'react-router-dom';
import { frontendTypeParam } from '../../routes';

export const useFrontendTypeParam = () => {
  const search = new URLSearchParams(useLocation().search);

  return search.get(frontendTypeParam) || undefined;
};
